/**
 * Table of Contents update via Word.run.
 * @module office/toc
 */

/* global Word */

/**
 * Attempts to update the document's Table of Contents.
 * Tries the dedicated TOC API first, then falls back to updating all fields.
 * @returns {Promise<boolean>} true if the update succeeded
 */
export async function updateTocWithRetry() {
  try {
    await Word.run(async (context) => {
      const tocs = context.document.tablesOfContents;
      if (tocs && typeof tocs.load === "function") {
        tocs.load("items");
        await context.sync();
        if (tocs.items.length > 0 && typeof tocs.items[0].updatePageNumbers === "function") {
          for (const toc of tocs.items) toc.updatePageNumbers();
          await context.sync();
          return;
        }
      }
      const fields = context.document.body.fields;
      fields.load("items");
      await context.sync();
      for (const field of fields.items) {
        if (typeof field.updateResult === "function") field.updateResult();
      }
      await context.sync();
    });
    return true;
  } catch {
    return false;
  }
}
